import { atomFamily } from "jotai/utils";
import { atomPersistor } from "./atomPersistor";

const phoneNumberAtom = atomFamily((sessionId: string | undefined) => atomPersistor(`${sessionId}-phoneNumber`, ""));

export { phoneNumberAtom };
